import React from "react";
import { cn } from "@/lib/utils";

const Footer = () => {
  return (
    <footer className="bg-[#31373d]/80 backdrop-blur-sm text-white py-4 mt-8">
      <div className="container mx-auto px-4 py-2">
        <div className="flex items-center justify-between">
          {/* Left: Logo + Name */}
          <div className="flex items-center gap-3">
            <img 
              src="/dyno.svg" 
              alt="Logo" 
              className="w-6 h-6 invert"
            />
            <span className="text-sm font-medium">DynoGraph Pro</span>
          </div>

          {/* Middle: Animated Quote */}
          <div className="text-center font-['Press_Start_2P'] text-[10px] opacity-80 overflow-hidden whitespace-nowrap">
            <style>
              {`
                @keyframes typewriter {
                  from { width: 0 }
                  to { width: 100% }
                }
                @keyframes blink {
                  50% { border-color: transparent }
                }
                .typewriter {
                  display: inline-block;
                  overflow: hidden;
                  border-right: .15em solid #fff;
                  white-space: nowrap;
                  animation: 
                    typewriter 8s steps(80, end) infinite,
                    blink .75s step-end infinite;
                }
              `}
            </style>
            <span className="typewriter">
              "If you no longer go for a gap that exists, you're no longer a racing driver."
            </span>
          </div>

          {/* Right: Powered by */}
          <div className="font-['Press_Start_2P'] text-[10px] opacity-80">
            Powered by
            <span className="text-primary ml-1">Enginebit</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
